import { combineReducers } from 'redux';
import { combineActions, handleAction } from 'redux-actions';

import { groupsReceived, resourcesReceived, unitInfoRequested, unitInfoReceived, unitsReceived } from '../actions/ehrResources';

import organization from './organization';
import session from './session';
import booking from './booking';
import app from './app';
import errors from './errors';
import cancelling from './cancelling';
import ticket from './ticket';
import history from './history';

const defaultReducer = {
  next(state, action) { return action.payload },
  throw(state, action) { throw action.payload }
};

const getMapper = key => (array) => {
  const map = Object.create(null);
  array.forEach((item) => {
    map[item[key]] = item;
  });
  return map;
};

const getMappingReducer = key => ({
  next(state, action) { return getMapper(key)(action.payload) },
  throw(state, action) { throw action.payload }
});

const unitInfoReducer = {
  next(state, action) {
    return {
      [action.payload.unit]: action.payload.notes || action.payload.loadingInfo
    };
  },
  throw(state, action) { throw action.payload }
};


export default combineReducers({
  errors,
  session,
  organization,
  booking,
  app,
  groups: handleAction(groupsReceived, defaultReducer, {}),
  resources: handleAction(resourcesReceived, getMappingReducer('resource'), {}),
  units: handleAction(unitsReceived, getMappingReducer('unit'), {}),
  unitInfos: handleAction(
    combineActions(unitInfoRequested, unitInfoReceived), unitInfoReducer, Object.create(null)),
  cancelling,
  ticket,
  history
});



// WEBPACK FOOTER //
// ./src/reducers/index.js